
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Kharghartopunecab() {



    const cardData =
    {
        keyword: ' Kharghar to Pune Cab',
        heading: 'Skyline Cabs: Kharghar to Pune Cab',
        headingDescription: 'Skyline Cabs provides reliable and comfortable Kharghar to Pune Cab service for a seamless intercity travel experience. Whether it’s a business trip, family visit, or a weekend getaway, our well-maintained vehicles and professional drivers ensure a safe and pleasant ride. With on-time pickups from Kharghar, transparent pricing, and 24/7 customer support, Skyline Cabs is your trusted choice for hassle-free travel. Book your Kharghar to Pune cab today and enjoy a smooth, worry-free journey.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
  {
    "name": "Kharghar to Pune Taxi",
    "description": "Skyline Cabs offers professional and dependable taxi services from Kharghar to Pune. Whether it's for business or a leisure trip, our fleet of vehicles ensures a smooth, safe, and timely journey."
  },
  {
    "name": "Kharghar to Pune Cab Cost",
    "description": "Get transparent and affordable cab fare from Kharghar to Pune with Skyline Cabs. Our pricing includes tolls and driver charges, offering you a fair and worry-free travel experience."
  },
  {
    "name": "Bandra Kurla Complex to Pune Cab",
    "description": "Travel from BKC to Pune with ease and comfort. Skyline Cabs provides on-time pickups, clean vehicles, and experienced drivers for a premium intercity cab experience."
  },
  {
    "name": "Mahim to Pune Cab Fare",
    "description": "Skyline Cabs offers competitive cab fares from Mahim to Pune. Book your ride online and enjoy reliable service with well-maintained vehicles for a comfortable trip."
  },
  {
    "name": "Kanjurmarg to Pune Cab",
    "description": "Choose Skyline Cabs for a smooth and affordable cab ride from Kanjurmarg to Pune. Our services are perfect for daily travelers, weekend plans, and business trips alike."
  },
  {
    "name": "Mumbra to Pune Cab Service",
    "description": "Skyline Cabs provides reliable and cost-effective cab service from Mumbra to Pune. With easy booking, clean vehicles, and courteous drivers, your travel experience will be pleasant and stress-free."
  },
  {
    "name": "Vikhroli to Pune Cab Service",
    "description": "Need a cab from Vikhroli to Pune? Skyline Cabs delivers timely, efficient, and affordable cab options with multiple vehicle choices including sedans and SUVs."
  },
  {
    "name": "Kharghar to Pune One Way Cab",
    "description": "Skyline Cabs offers convenient and budget-friendly one-way cab service from Kharghar to Pune. Enjoy a clean, private ride with no return charges or hidden fees."
  },
  {
    "name": "Kharghar to Pune Round Trip Cab",
    "description": "Book a round trip cab from Kharghar to Pune with Skyline Cabs and get flexible return schedules and discounted rates on round journeys. Ideal for short business visits or family trips."
  },
  {
    "name": "Kalina to Pune Cab",
    "description": "Skyline Cabs provides dependable and comfortable cab services from Kalina to Pune. Choose from our wide range of vehicles and travel worry-free with trained chauffeurs and support."
  },
  {
    "name": "Cab Service in Kharghar Mumbai",
    "description": "Skyline Cabs is your local and outstation cab partner in Kharghar, Mumbai. Book rides to Pune, Lonavala, or Mumbai Airport easily with our clean vehicles and experienced drivers."
  },
  {
    "name": "Ertiga Cab in Kharghar Mumbai",
    "description": "For family or group travel, Skyline Cabs offers spacious and comfortable Ertiga cabs in Kharghar. Ideal for long trips to Pune or nearby getaways, our Ertigas offer both comfort and value."
  },
  {
    "name": "Ertiga Taxi Fare in Kharghar",
    "description": "Skyline Cabs provides affordable and transparent fare options for Ertiga taxis in Kharghar. Great for intercity travel, especially when comfort and space are priorities."
  },
  {
    "name": "Innova Cab in Kharghar",
    "description": "Travel in style and comfort with Skyline’s Innova cabs in Kharghar. Perfect for business or family trips to Pune, our Innova fleet is clean, spacious, and driven by professionals."
  },
  {
    "name": "Kharghar Cab Service",
    "description": "Skyline Cabs offers all-round cab services in Kharghar for local, airport, and outstation travel. Easy booking, fair pricing, and dependable service make us the preferred choice in the area."
  },
  {
    "name": "Outstation Cab Service in Kharghar",
    "description": "Skyline Cabs provides trusted outstation taxi services from Kharghar to Pune, Lonavala, and more. Our easy booking and wide range of vehicles make your trip planning effortless and enjoyable."
  },
  {
    "name": "Best Taxi Service in Kharagpur",
    "description": "If you’re in Kharagpur and looking for a top-rated taxi service, Skyline Cabs is here for you. We offer reliable, safe, and affordable cabs with experienced drivers for all your travel needs."
  }
],
"tableData": [
  ["Kharghar to Pune Taxi", "Kharghar to Pune Cab Cost"],
  ["Bandra Kurla Complex to Pune Cab", "Mahim to Pune Cab Fare"],
  ["Kanjurmarg to Pune Cab", "Mumbra to Pune Cab Service"],
  ["Vikhroli to Pune Cab Service", "Kharghar to Pune One Way Cab"],
  ["Kharghar to Pune Round Trip Cab", "Kalina to Pune Cab"],
  ["Cab Service in Kharghar Mumbai", "Ertiga Cab in Kharghar Mumbai"],
  ["Ertiga Taxi Fare in Kharghar", "Innova Cab in Kharghar"],
  ["Kharghar Cab Service", "Outstation Cab Service in Kharghar"],
  ["Best Taxi Service in Kharagpur"]
],



whychoose: [
    {
        "WhyChooseheading": "Reliable Kharghar to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers prompt and dependable cab services from Kharghar to Pune. Whether you're traveling for work, leisure, or an emergency, our service ensures timely and stress-free travel."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Enjoy a smooth ride in our clean, air-conditioned sedans, SUVs, and premium vehicles. Each cab is regularly maintained to provide you with a safe and comfortable journey from Kharghar to Pune."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our courteous and skilled drivers know the Kharghar to Pune route thoroughly. They ensure a safe, smooth, and punctual journey while maintaining the highest standards of professionalism."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "We provide upfront pricing with no hidden charges. Get the best value for your money with our budget-friendly yet high-quality Kharghar to Pune cab service."
    },
    {
        "WhyChooseheading": "Available 24/7 for Your Convenience",
        "WhyChoosedescription": "Travel at your convenience—morning, night, or anytime in between. Skyline Cabs operates round-the-clock, making it easy to book a Kharghar to Pune cab whenever you need it."
    },
    {
        "WhyChooseheading": "Quick Online Booking with Instant Confirmation",
        "WhyChoosedescription": "Book your ride in minutes through our website or mobile app. Get instant booking confirmation, driver details, and real-time ride tracking for a seamless experience."
    },
    {
        "WhyChooseheading": "Sanitized Cabs with Safety Measures",
        "WhyChoosedescription": "Your safety is our top priority. All our vehicles are thoroughly sanitized before every trip, and our drivers follow strict hygiene protocols to ensure a safe ride."
    },
    {
        "WhyChooseheading": "Vehicle Options for Every Traveler",
        "WhyChoosedescription": "Whether you're traveling solo, with family, or in a group, we have the right vehicle for you—from compact sedans to spacious SUVs. Choose what suits you best for the Kharghar to Pune journey."
    }
]




























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Kharghar to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Kharghar to Pune with Skyline Cabs is quick and easy. You can book through our website, mobile app, or by calling our customer support. Just enter your pickup and drop-off details, choose a vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What vehicle options are available for the Kharghar to Pune trip?',
            answer:
                'We offer a wide range of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. You can choose the vehicle that best fits your travel needs and comfort preferences.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Kharghar to Pune?',
            answer:
                'The average travel time from Kharghar to Pune is about 3.5 to 5 hours, depending on traffic and road conditions. Our drivers take the best possible routes for a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Are the fares from Kharghar to Pune fixed?',
            answer:
                'Yes, we offer fixed and upfront pricing. Your fare includes all tolls, taxes, and driver fees, ensuring transparency with no hidden charges.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab from Kharghar to Pune?',
            answer:
                'Yes, round-trip cab bookings are available. Just provide your return travel details during the booking process and we’ll arrange everything for you.',
        },
        {
            id: 6,
            question: 'Can I modify or cancel my Kharghar to Pune booking?',
            answer:
                'Absolutely! You can easily modify or cancel your booking using our website, mobile app, or by contacting our customer support team. We offer flexible options to accommodate your schedule.',
        },
        {
            id: 7,
            question: 'Are your cabs clean and well-maintained?',
            answer:
                'Yes, all our cabs are regularly serviced, cleaned, and inspected to ensure your safety and comfort during the journey.',
        },
        {
            id: 8,
            question: 'What payment options are available for Kharghar to Pune cab bookings?',
            answer:
                'You can pay online using UPI, credit/debit cards, and net banking. We also accept cash payments at the end of your ride.',
        },
        {
            id: 9,
            question: 'Is corporate travel available from Kharghar to Pune?',
            answer:
                'Yes, Skyline Cabs provides reliable corporate travel solutions. We cater to executives, business travelers, and teams with professional service and tailored packages.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for your Kharghar to Pune journey?',
            answer:
                'Skyline Cabs offers punctual service, professional drivers, a variety of clean and comfortable vehicles, and upfront pricing. We ensure a stress-free ride from Kharghar to Pune.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Ramesh Verma",
            rating: 5,
            review: "I booked a Skyline Cab from Kharghar to Pune and had a very pleasant experience. The car was clean, the driver was polite, and we reached on time. Great service!"
        },
        {
            name: "Miss. Sonal Gupta",
            rating: 4,
            review: "Smooth booking process and a comfortable ride from Kharghar to Pune. I’ll definitely consider Skyline Cabs for my future trips."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kharghar to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/kharghar-to-pune-cab.jpg",
  "description": "Book Kharghar to Pune cab with Skyline Cabs for a safe, comfortable, and affordable ride. AC sedans, SUVs, and premium cabs available 24/7 with expert drivers for one-way or round-trip bookings.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7816"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1399",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/kharghar-to-pune-cab"
  }
};



      

      


    return (
        <div>
      <Helmet>
  <title>Kharghar to Pune Cab | AC Taxi Booking 24/7 | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Kharghar to Pune cab with Skyline Cabs for a safe, comfortable, and affordable ride. AC sedans, SUVs, and premium cabs available 24/7 with expert drivers for one-way or round-trip bookings." 
  />
  <meta 
    name="keywords" 
    content="Kharghar to Pune Cab, Cab from Kharghar to Pune, One-Way Taxi Kharghar to Pune, Round Trip Cab Kharghar to Pune, AC Cab Kharghar to Pune, SUV Taxi Kharghar to Pune, Online Cab Booking Kharghar to Pune, 24/7 Cab Service Kharghar to Pune, Skyline Cabs Kharghar to Pune, Affordable Taxi Kharghar to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/61.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kharghartopunecab;